 // @ts-nocheck
import React, { useEffect, useState, ChangeEvent } from 'react'
import { fetchUserActivity } from './../services/consultant/opportunityService'
import ConsultantLayout from 'consultantLayout'
import { httpVerbConstants } from 'constants/actionTypes'
import { Container } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import * as E from './consultantUserActivityElements'
import { formatDateToString } from 'helpers'
import { Pill } from '@mmsg/louie'
import { theme } from 'utils/theme'
import { Icon } from 'icons'
import { fetchOpportunityInfo as consultantFetchOpportunityInfo } from 'actions/consultantOpportunityActions'
import ReactPaginate from 'react-paginate'

interface ICustomerAnalytics {
  firstName: string
  lastName: string
  successfullyAccessedCount: number
  lastAccessedDateTime: Date[]
}
enum OpportunityStatusType {
  NotLoggedIn = 'NotLoggedIn',
  EstimateAtReview = 'EstimateAtReview',
  EstimateAccepted = 'EstimateAccepted',
  ProposalAtReview = 'ProposalAtReview',
  ProposalAccepted = 'ProposalAccepted',
  LoggedIn = 'LoggedIn',
}
interface IProposalAnalytics {
  successfullyAccessedCount: number
  lastAccessedDateTime: Date[]
  dateSent: Date
}

interface IUserActivity {
  createdOn: string
  customerAnalytics: {
    firstName: string
    lastName: string
    validUntil: Date
    eventAnalytics: {
      lastAccessedDateTime: Date[]
      successfullyAccessedCount: number
    }
  }
  opportunityID: string
  opportunityStatus: string
  proposalAnalytics: { createdOn: string; eventAnalytics: any }
  quotesAnalytics: any
}

const ConsultantUserActivity = () => {
  const [userActivity, setUserActivity] = useState<any[]>([])
  const [newUserActivity, setNewUserActivity] = useState<any[]>([])
  const [statusFilterState, setStatusFilterState] = useState(false)
  const [getCurrentStatus, setGetCurrentStatus] = useState('all')
  const [getCurrentIndex, setGetCurrentIndex] = useState(0)
  const [currentSearchValue, setCurrentSearchValue] = useState('')

  let currentCustomer: string

  let currentOppId = useSelector(
    (state: any) => state.authentication.opportunityId
  )
  let consultantEmail = useSelector(
    (state: any) => state.auth.idToken && state.auth.idToken.claims.email
  )
  const { accessToken } = useSelector((state: any) => state.auth)
  const headers = { accessToken: accessToken }

  // let data = [
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710616',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Vishnu',
  //       lastName: 'V',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Vishnu',
  //       lastName: 'V',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAccepted',
  //     customerAnalytics: {
  //       firstName: 'Last',
  //       lastName: 'Hope',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'NotLoggedIn',
  //     customerAnalytics: {
  //       firstName: 'Rachel',
  //       lastName: 'Green',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Vishnu',
  //       lastName: 'V',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAccepted',
  //     customerAnalytics: {
  //       firstName: 'Last',
  //       lastName: 'Hope',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'NotLoggedIn',
  //     customerAnalytics: {
  //       firstName: 'Rachel',
  //       lastName: 'Green',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Vishnu',
  //       lastName: 'V',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAccepted',
  //     customerAnalytics: {
  //       firstName: 'Last',
  //       lastName: 'Hope',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'NotLoggedIn',
  //     customerAnalytics: {
  //       firstName: 'Rachel',
  //       lastName: 'Green',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Vishnu',
  //       lastName: 'V',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAccepted',
  //     customerAnalytics: {
  //       firstName: 'Last',
  //       lastName: 'Hope',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'NotLoggedIn',
  //     customerAnalytics: {
  //       firstName: 'Rachel',
  //       lastName: 'Green',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Vishnu',
  //       lastName: 'V',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAccepted',
  //     customerAnalytics: {
  //       firstName: 'Last',
  //       lastName: 'Hope',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'NotLoggedIn',
  //     customerAnalytics: {
  //       firstName: 'Rachel',
  //       lastName: 'Green',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Vishnu',
  //       lastName: 'V',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAccepted',
  //     customerAnalytics: {
  //       firstName: 'Last',
  //       lastName: 'Hope',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'NotLoggedIn',
  //     customerAnalytics: {
  //       firstName: 'Rachel',
  //       lastName: 'Green',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Vishnu',
  //       lastName: 'V',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAccepted',
  //     customerAnalytics: {
  //       firstName: 'Last',
  //       lastName: 'Hope',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'NotLoggedIn',
  //     customerAnalytics: {
  //       firstName: 'Rachel',
  //       lastName: 'Green',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Brendon',
  //       lastName: 'Frazer',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Adam',
  //       lastName: 'Sandler',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Vishnu',
  //       lastName: 'V',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Princess',
  //       lastName: 'Leya',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Brad',
  //       lastName: 'Pitt',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Vishnu',
  //       lastName: 'V',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'heyo',
  //       lastName: 'V',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Jodie',
  //       lastName: 'Foster',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Angelina',
  //       lastName: 'Jolie',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'EstimateAtReview',
  //     customerAnalytics: {
  //       firstName: 'Megan',
  //       lastName: 'Foxxx',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'ProposalAccepted',
  //     customerAnalytics: {
  //       firstName: 'Samuel L',
  //       lastName: 'Jackson',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  //   {
  //     opportunityID: 'c08cc195-c1fc-4c57-8f5e-95d180710613',
  //     createdOn: '2023-03-20T00:00:00',
  //     opportunityStatus: 'LoggedIn',
  //     customerAnalytics: {
  //       firstName: 'whoIsThat',
  //       lastName: '?',
  //       validUntil: '2023-03-29T00:30:44.4430249Z',
  //       eventAnalytics: {
  //         successfullyAccessedCount: 2,
  //         lastAccessedDateTime: [
  //           '2023-03-28T04:45:58.8666732Z',
  //           '2023-03-29T00:26:59.2452235Z',
  //         ],
  //       },
  //     },
  //     quotesAnalytics: [
  //       {
  //         quoteID: '6f078e75-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5980',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 3,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:05.0311466Z',
  //             '2023-03-28T04:52:48.9661403Z',
  //             '2023-03-28T04:52:56.8855676Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: '014539ac-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5981',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: {
  //           successfullyAccessedCount: 2,
  //           lastAccessedDateTime: [
  //             '2023-03-28T04:46:20.2977024Z',
  //             '2023-03-29T00:27:05.9281702Z',
  //           ],
  //         },
  //       },
  //       {
  //         quoteID: 'e4d367d0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5982',
  //         createdOn: '0001-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //       {
  //         quoteID: '7b25ccf0-ded5-ea11-a813-000d3ad1cd5b',
  //         nlQuoteNumber: 'NLQ_5983',
  //         createdOn: '2020-01-01T00:00:00',
  //         eventAnalytics: null,
  //       },
  //     ],
  //     proposalAnalytics: {
  //       createdOn: '0001-01-01T00:00:00',
  //       eventAnalytics: null,
  //     },
  //   },
  // ]

  let data: any[] = []
  useEffect(() => {
    if (data) {
      setUserActivity(data)
      setNewUserActivity(data)
    }
  }, [])
  const itemsPerPage = 10
  useEffect(() => {
    fetchUserActivity(consultantEmail, headers, httpVerbConstants.HTTP_GET)
      .then((data: IUserActivity[]) => {
        if (data) {
          setUserActivity(data)
          setNewUserActivity(data)
        }
      })
      .catch((e: any) => console.log('Error: ', e))
  }, [])

  const formatStatusText = (apiStatusText: string | undefined) => {
    switch (apiStatusText) {
      case OpportunityStatusType.ProposalAtReview:
        return 'Proposal'

      case OpportunityStatusType.ProposalAccepted:
        return 'Proposal Accepted'

      case OpportunityStatusType.NotLoggedIn:
        return 'Never logged'

      case OpportunityStatusType.LoggedIn:
        return 'Logged in'

      case OpportunityStatusType.EstimateAtReview:
        return 'Estimate'

      case OpportunityStatusType.EstimateAccepted:
        return 'Estimate Accepted'
    }
  }

  const formatStatusColour = (apiStatusText: string | undefined) => {
    switch (apiStatusText) {
      case OpportunityStatusType.ProposalAtReview:
        return '#B05CCB'

      case OpportunityStatusType.ProposalAccepted:
        return '#0FAD12'

      case OpportunityStatusType.NotLoggedIn:
        return '#FF4141'

      case OpportunityStatusType.LoggedIn:
        return '#808080'

      case OpportunityStatusType.EstimateAtReview:
        return '#2468F5'

      case OpportunityStatusType.EstimateAccepted:
        return '#22ACB0'
    }
  }

  const crmLink = (url: string) => {
    window.open(url, '_blank')
  }

  const searchingUser = (e: ChangeEvent<HTMLInputElement>) => {
    let newData: any[] = []

    setCurrentSearchValue(e.target.value.trim())
    userActivity.map(
      (item: any) =>
        (
          item?.customerAnalytics?.firstName.toString().toLowerCase().trim() +
          item?.customerAnalytics?.lastName.toString().toLowerCase().trim()
        ).includes(e.target.value.toString().toLowerCase().trim()) &&
        (item.opportunityStatus == getCurrentStatus ||
          getCurrentStatus == 'all') &&
        newData.push(item)
    )

    // data = newData
    setNewUserActivity(newData)
  }

  const updateCurrentStatus = (i: any) => {
    setGetCurrentStatus(i)
    let newData: any[] = []
    userActivity.map(
      (item: any) =>
        (
          item?.customerAnalytics?.firstName.toString().toLowerCase().trim() +
          item?.customerAnalytics?.lastName.toString().toLowerCase().trim()
        ).includes(currentSearchValue.toString().toLowerCase().trim()) &&
        (item.opportunityStatus == i || i == 'all') &&
        newData.push(item)
    )
    // data = newData
    setNewUserActivity(newData)

    setStatusFilterState(!statusFilterState)
  }
  const onStatusFilterClick = () => {
    setStatusFilterState(!statusFilterState)
  }
  const dispatch = useDispatch()

  const fetchNewOpportunity = (oppId: string) => {
    dispatch(
      consultantFetchOpportunityInfo(oppId, headers, httpVerbConstants.HTTP_GET)
    )
  }

  // 3rd party component event on page change

  const onCurrentIndexSet = (event: any) => {
    setGetCurrentIndex(event.selected && event.selected * itemsPerPage)
  }
  let totalPages = Math.ceil(newUserActivity.length / itemsPerPage)

  return (
    <Container>
      <ConsultantLayout>
        <br></br>
        <br></br>

        <E.SingleUserHeaderDiv theme={theme}>
          <E.SingleUserColDiv>User Name</E.SingleUserColDiv>
          <E.SingleUserColDiv>Status</E.SingleUserColDiv>
          <E.SingleUserColDiv>Views</E.SingleUserColDiv>
          <E.SingleUserColDiv>Date Sent</E.SingleUserColDiv>
          <E.SingleUserColDiv>Date Accessed</E.SingleUserColDiv>
          <E.SingleUserColDiv>Actions</E.SingleUserColDiv>
        </E.SingleUserHeaderDiv>
        {userActivity.map(
          (item: any) =>
            item.opportunityID == currentOppId && (
              <E.SingleUserRowDiv>
                <E.SingleUserColDiv>
                  {item?.customerAnalytics?.firstName +
                    ' ' +
                    item?.customerAnalytics?.lastName}
                </E.SingleUserColDiv>
                <E.SingleUserColDiv>
                  <Pill
                    text={formatStatusText(item?.opportunityStatus)}
                    outlineColor={formatStatusColour(item?.opportunityStatus)}
                  />
                </E.SingleUserColDiv>
                <E.SingleUserColDiv>
                  {item.opportunityStatus == ''}
                  {item?.customerAnalytics?.eventAnalytics
                    ?.successfullyAccessedCount
                    ? item.customerAnalytics.eventAnalytics
                        .successfullyAccessedCount
                    : 0}
                </E.SingleUserColDiv>
                <E.SingleUserColDiv>
                  {formatDateToString(item.createdOn, ' ', true)}
                </E.SingleUserColDiv>
                <E.SingleUserColDiv>
                  {item?.customerAnalytics?.eventAnalytics
                    ?.lastAccessedDateTime[0]
                    ? formatDateToString(
                        item.customerAnalytics.eventAnalytics
                          .lastAccessedDateTime[0],
                        ' ',
                        false,
                        true,
                        false
                      )
                    : ''}
                </E.SingleUserColDiv>
                <E.SingleUserColDiv>
                  <Pill
                    text="CRM"
                    outlineColor={theme.colors.primary}
                    textColor={theme.colors.primary}
                    ClickFunc={() => crmLink(item?.D365OpportunityUrl)}
                  />
                </E.SingleUserColDiv>
              </E.SingleUserRowDiv>
            )
        )}
        <br></br>
        <br></br>

        <E.SingleUserTable theme={theme}>
          <h4>User Activity</h4>
          <E.SubHeadingTag>
            <h5>Search</h5>
            <h5>Status Filter</h5>
          </E.SubHeadingTag>
          <E.FilterOption>
            <E.ActivityInput>
              <input
                type="text"
                id="name"
                name="name"
                placeholder=" Search User Name"
                onChange={searchingUser}
              />{' '}
              <Icon iconType="Search" />
            </E.ActivityInput>
            <div>
              <E.ActivityInput onClick={onStatusFilterClick}>
                <input
                  type="text"
                  value={
                    getCurrentStatus == 'all'
                      ? 'All'
                      : formatStatusText(getCurrentStatus)
                  }
                  onClick={onStatusFilterClick}
                  readOnly
                />
                <Icon iconType="DropDown" />
              </E.ActivityInput>
              {statusFilterState && (
                <E.ActivityFilterBlock>
                  <button onClick={() => updateCurrentStatus('all')}>
                    All
                  </button>
                  <br />
                  {Object.keys(OpportunityStatusType).map((item) => (
                    <>
                      <button onClick={() => updateCurrentStatus(item)}>
                        {formatStatusText(item)}
                      </button>
                      <br />
                    </>
                  ))}
                </E.ActivityFilterBlock>
              )}
            </div>
          </E.FilterOption>
          <E.SingleUserHeaderDiv theme={theme}>
            <E.SingleUserColDiv>User Name</E.SingleUserColDiv>
            <E.SingleUserColDiv>Status</E.SingleUserColDiv>
            <E.SingleUserColDiv>Views</E.SingleUserColDiv>
            <E.SingleUserColDiv>Date Sent</E.SingleUserColDiv>
            <E.SingleUserColDiv>Date Accessed</E.SingleUserColDiv>
            <E.SingleUserColDiv>Actions</E.SingleUserColDiv>
          </E.SingleUserHeaderDiv>
          {newUserActivity.map(
            (item: any, i: number) =>
              i >= getCurrentIndex &&
              i < getCurrentIndex + itemsPerPage && (
                <E.SingleUserRowDiv>
                  <E.SingleUserColDiv>
                    <E.ActivityUserLink
                      onClick={() => fetchNewOpportunity(item.opportunityID)}
                    >
                      {item?.customerAnalytics?.firstName +
                        ' ' +
                        item?.customerAnalytics?.lastName}
                    </E.ActivityUserLink>
                  </E.SingleUserColDiv>
                  <E.SingleUserColDiv>
                    <Pill
                      text={formatStatusText(item?.opportunityStatus)}
                      outlineColor={formatStatusColour(item?.opportunityStatus)}
                    />
                  </E.SingleUserColDiv>
                  <E.SingleUserColDiv>
                    {item.opportunityStatus == ''}
                    {item?.customerAnalytics?.eventAnalytics
                      ?.successfullyAccessedCount
                      ? item.customerAnalytics.eventAnalytics
                          .successfullyAccessedCount
                      : 0}
                  </E.SingleUserColDiv>
                  <E.SingleUserColDiv>
                    {formatDateToString(item.createdOn, ' ', true)}
                  </E.SingleUserColDiv>
                  <E.SingleUserColDiv>
                    {item?.customerAnalytics?.eventAnalytics
                      ?.lastAccessedDateTime[0]
                      ? formatDateToString(
                          item.customerAnalytics.eventAnalytics
                            .lastAccessedDateTime[0],
                          ' ',
                          false,
                          true,
                          false
                        )
                      : ''}
                  </E.SingleUserColDiv>
                  <E.SingleUserColDiv>
                    <Pill
                      text="CRM"
                      outlineColor={theme.colors.primary}
                      textColor={theme.colors.primary}
                      ClickFunc={() => crmLink('https://www.google.com')}
                    />
                  </E.SingleUserColDiv>
                </E.SingleUserRowDiv>
              )
          )}
          <ReactPaginate
            previousLabel="Previous"
            nextLabel="Next"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            pageCount={totalPages}
            marginPagesDisplayed={1}
            pageRangeDisplayed={2}
            onPageChange={onCurrentIndexSet}
            containerClassName="pagination"
            activeClassName="active"
            // forcePage={pageOffset}
          />
        </E.SingleUserTable>
      </ConsultantLayout>
    </Container>
  )
}

export default ConsultantUserActivity
